// actions/websiteSettingActions.js
import WebsiteSettingsServices from "../services/websiteSettingsService";

export const GET_HOME_PAGE_SETTING_REQUEST = "GET_HOME_PAGE_SETTING_REQUEST";
export const GET_HOME_PAGE_SETTING_SUCCESS = "GET_HOME_PAGE_SETTING_SUCCESS";
export const GET_HOME_PAGE_SETTING_FAILED = "GET_HOME_PAGE_SETTING_FAILED";

// Thunk Action
export const getHomePageSetting = () => {
  return async (dispatch) => {
    dispatch({ type: GET_HOME_PAGE_SETTING_REQUEST });

    try {
      const res = await WebsiteSettingsServices.getHomePageSetting();

      dispatch({
        type: GET_HOME_PAGE_SETTING_SUCCESS,
        payload: res, // The homepage setting object
      });
    } catch (err) {
      dispatch({
        type: GET_HOME_PAGE_SETTING_FAILED,
        payload: err?.message || "Error fetching homepage settings",
      });
    }
  };
};
